
import { defineComponent, ref, inject, onMounted, computed, watch, nextTick } from 'vue'
import { Search } from '@element-plus/icons-vue'
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useRouter } from 'vue-router';
import { useStore } from "vuex";
//services
import EventService from "@/core/services/EventService"
import GlobalService from '@/core/services/GlobalService';
import { errManager, showNotification } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
import ColorThief from 'color-thief-browser'

//components
import AddEditEvent from "./modals/AddEditEvent.vue"
import CardEvent from "@/components/cards/Card5.vue"

export default defineComponent({
    name: "Events",
    components: {
        AddEditEvent, CardEvent
    },
    setup() {
        const { t } = useI18n();
        const store = useStore();
        const router = useRouter();
        const loader = ref(false);
        //get sharing data
        const gblPeriodo = inject < any > ('gblPeriodo')
        const gblDialog = inject < any > ('gblDialog')
        const gblAction = inject < any > ('gblAction')
        
        const listEvents = ref <any> ([]);
        const listSeats = ref <any> ([]);
        const searchText = ref('')
        const setting = ref({})
        const filter = ref({
            type: '',
            periodo: ''
        })
        const rowItem = ref({});
        const AddEditEventRef = ref<any>(null);

        const company = computed(() => {
            return store.getters.currentUser.company
        });

        const getSeats = async() => {
            const res = await GlobalService.get('api', `seats?limit=0&page=1`);
            listSeats.value =  res.data?.data || [];
        }

        const getEventos = async () => {
            try {
                loader.value = true
                listEvents.value.length = 0
                filter.value.periodo = gblPeriodo.value

                const res = await EventService.getList(filter.value)
                listEvents.value = res.data

                await nextTick();

                listEvents.value.forEach((evento, index) => {
                    const img = new Image()
                    img.crossOrigin = 'anonymous'
                    img.src = evento.logo
                    img.onload = async () => {
                        const colorThief = new ColorThief()
                        const color = await colorThief.getColor(img)
                        listEvents.value[index].backgroundColor = `rgb(${color[0]}, ${color[1]}, ${color[2]})`
                        console.log(color)
                    }
                });

                loader.value = false

            } catch (error: any) {
                loader.value = false
                errManager(error.response)
            }
        }

        const getSetting = async () => {
            await EventService.getSetting()
            .then( (res) => {
                setting.value = res.data
            }).catch( ({response}) => {
                errManager(response, null, 2)
            })
        }

        const filteredEvents = computed(() => {
            return listEvents.value.filter(
                (item) =>
                item.name.toLowerCase().includes(searchText.value.toLowerCase())
            );
        });

        const openModal = (data: any) => {
            if(AddEditEventRef.value){
                rowItem.value = data;
                AddEditEventRef.value.openModal();
            }
        }

        const onResponse = (data) => {
            if(!data) return;
            if(data.status == 'success') getEventos();
        }

        const getRegisterClass = (register) => {
            return register == 1 ? 'success' : 'danger'
        }

        const getRegisterStatus = (register) => {
            return register == 1 ? 'habilitadas' : 'finalizadas'
        }

        const getDate = (date1: any, date2: any) => {
            let dat1 = moment(date1).format("DD MMM")
            let dat2 = moment(date1).format("DD/MM/YYYY") != moment(date2).format("DD/MM/YYYY") ? ' al ' + moment(date2).format('DD MMM YYYY') : ''

            return dat1 + `<span>${dat2}</span>`
        }

        const onEditAction = (row) => {
            console.info(row)
            openModal(row);
        } 

        const onDeleteAction = (row: any) => {
            Swal.fire({
              title: t('deleteRecord'),
                html: t('deleteText', {text: row.name}),
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: t('cancel'),
                confirmButtonText: t('delete'),
                reverseButtons: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: "#d33",
                preConfirm: () => {
                    return GlobalService.delete('events', `${row.idevent}/delete`, {})
                    .then((res) => {
                        return res.data;
                    }).catch(({ response })=>{
                        Swal.showValidationMessage(
                            `Request failed: ${response}`
                        )
                    });
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    showNotification({title: result.value.title, message: result.value.message, status: result.value.status});
                    result.value.status === 'success' && getEventos();
                }
            })
        }

        onMounted(() => {
            searchText.value = ''
            filter.value.type = ''
            filter.value.periodo = gblPeriodo.value
            getSeats();
            getSetting()
            getEventos()
        })

        watch(() => gblPeriodo.value, getEventos);

        return {
            t,
            loader,
            Search,
            gblPeriodo,
            filter,
            rowItem,
            searchText,
            listEvents,
            listSeats,
            setting,
            AddEditEventRef,
            //events
            company,
            getEventos,
            getSetting,
            filteredEvents,
            openModal,
            onResponse,
            getRegisterClass,
            getRegisterStatus,
            getDate,
            onEditAction,
            onDeleteAction,
        }
    }
})
